import { z } from 'zod';

import i18n from '~/utils/i18n';

const requiredString = () =>
  z
    .string()
    .trim()
    .min(1, {
      message: i18n.t(($) => $.validation.required, { ns: 'bugReport' }),
    });

export const zodBugReportSchema = z.object({
  actualBehavior: requiredString(),
  expectedBehavior: requiredString(),
  reporterName: requiredString(),
  stepsToReproduce: requiredString(),
  title: requiredString(),
  videoLink: z.string().trim(),
});

export type BugReportFormValues = z.infer<typeof zodBugReportSchema>;

/**
 * Lenient schema for deserializing a persisted draft from localStorage.
 * Uses plain strings (no min-length) so partial drafts can still be restored.
 */
export const zodBugReportDraftSchema = z.object({
  actualBehavior: z.string(),
  expectedBehavior: z.string(),
  lastUpdatedAt: z.number(),
  reporterName: z.string(),
  stepsToReproduce: z.string(),
  title: z.string(),
  videoLink: z.string(),
});
